import React from 'react'
import { MssProviderEmailDto } from '@services/dtos'
import { Typography } from '@mui/material'

type Props = {
  email: MssProviderEmailDto
  onClose: () => void
}

const MssEmailForm: React.FC<Props> = ({ email, onClose }) => {
  return (
    <div className="p-6">
      <Typography variant="h6" component="div" color="primary">
        {email.subject}
      </Typography>
      <Typography variant="body1" mt={2}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tristique
        commodo commodo. Mauris eget tristique dui. Aliquam fermentum
        ullamcorper massa at gravida. Nam auctor eros mauris, et mattis sem
        dapibus mollis. Donec auctor, nisl malesuada pellentesque dapibus, ipsum
        metus cursus est, vitae commodo elit massa sed nisi. Suspendisse
        porttitor non ipsum id ornare. Nunc in purus sed sapien condimentum
        faucibus. Aenean tempus nibh nec erat dictum luctus. Maecenas interdum,
        urna vel tristique tempus, magna justo mollis lectus, pulvinar aliquet
        elit orci quis est. Aenean venenatis, tortor vel consequat egestas,
        metus lorem dictum nisl, eu gravida lorem augue non eros.
      </Typography>
    </div>
  )
}

export default MssEmailForm
